import React from "react";
import founderImage from "../../../public/founder.jpg";

const FounderStory = () => {
  return (
    <section id="founder" className="py-24 bg-white relative overflow-hidden">
      {/* More Visible Bubble Patterns */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Primary Large Bubbles */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
            radial-gradient(circle at 50% 50%, rgba(137, 184, 194, 0.2) 0%, transparent 50%),
            radial-gradient(circle at 0% 0%, rgba(230, 243, 240, 0.25) 0%, transparent 40%),
            radial-gradient(circle at 100% 100%, rgba(230, 239, 246, 0.25) 0%, transparent 40%)
          `,
            backgroundSize: "100px 100px, 120px 120px, 120px 120px",
            backgroundPosition: "center, 0 0, 0 0",
            opacity: 0.7,
          }}
        ></div>

        {/* Visible Floating Bubbles */}
        <div className="absolute top-1/4 left-10 w-64 h-64 rounded-full bg-gradient-to-br from-[#E6F3F0]/30 to-[#E6EFF6]/30 blur-xl animate-float-slow"></div>
        <div
          className="absolute top-1/3 right-20 w-56 h-56 rounded-full bg-gradient-to-tl from-[#E6F3F0]/35 to-[#E6EFF6]/35 blur-lg"
          style={{
            animation: "float 8s ease-in-out infinite",
            animationDelay: "1s",
          }}
        ></div>
        <div
          className="absolute bottom-1/4 left-1/4 w-72 h-72 rounded-full bg-gradient-to-tr from-[#E6F3F0]/30 to-[#E6EFF6]/30 blur-xl"
          style={{
            animation: "float 10s ease-in-out infinite",
            animationDelay: "1.5s",
          }}
        ></div>
        <div
          className="absolute top-1/2 right-1/3 w-60 h-60 rounded-full bg-gradient-to-bl from-[#E6F3F0]/32 to-[#E6EFF6]/32 blur-lg"
          style={{
            animation: "float 9s ease-in-out infinite",
            animationDelay: "2s",
          }}
        ></div>

        {/* Small Bubble Accents */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
            radial-gradient(circle at 20% 20%, rgba(137, 184, 194, 0.2) 0%, transparent 5%),
            radial-gradient(circle at 80% 80%, rgba(137, 184, 194, 0.2) 0%, transparent 5%),
            radial-gradient(circle at 50% 50%, rgba(137, 184, 194, 0.15) 0%, transparent 6%)
          `,
            backgroundSize: "140px 140px",
            opacity: 0.8,
          }}
        ></div>

        {/* Additional Small Bubbles */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
            radial-gradient(circle at 30% 70%, rgba(137, 184, 194, 0.18) 0%, transparent 4%),
            radial-gradient(circle at 70% 30%, rgba(137, 184, 194, 0.18) 0%, transparent 4%)
          `,
            backgroundSize: "120px 120px",
            opacity: 0.7,
          }}
        ></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative">
        <div className="max-w-7xl mx-auto">
          {/* Enhanced Section Header */}
          <div className="text-center mb-16">
            <h2 className="font-heading text-4xl md:text-5xl xl:text-6xl font-bold bg-gradient-to-r from-[#2C5364] to-[#203A43] bg-clip-text text-transparent mb-6 leading-tight">
              Meet the Founder
            </h2>
            <div className="w-32 h-1.5 bg-gradient-to-r from-[#89B8C2] via-[#7AA6B6] to-[#89B8C2] rounded-full mx-auto transform hover:scale-110 transition-transform duration-300"></div>
          </div>

          {/* Main Content Grid */}
          <div className="grid md:grid-cols-2 gap-8 lg:gap-16 xl:gap-24 items-start mb-20">
            {/* Enhanced Founder Image */}
            <div className="relative group">
              <div className="w-full mx-auto">
                <div className="relative w-full aspect-square max-w-[280px] sm:max-w-[350px] md:max-w-[400px] lg:max-w-[500px] mx-auto transform group-hover:scale-[1.02] transition-transform duration-300">
                  {/* Decorative Ring */}
                  <div className="absolute -inset-4 bg-gradient-to-br from-[#E6F3F0]/40 to-[#E6EFF6]/40 blur-md group-hover:blur-lg transition-all duration-300"></div>

                  {/* Main Image Container */}
                  <div className="absolute inset-0 bg-gradient-to-br from-[#E6F3F0] to-[#E6EFF6] p-3 sm:p-4 shadow-lg group-hover:shadow-xl transition-shadow duration-300">
                    <div className="w-full h-full overflow-hidden border-4 border-white shadow-inner">
                      <img
                        src={founderImage}
                        alt="Neeru Gupta Mishra - Founder of Cittasya"
                        className="w-full h-full object-cover transform transition-transform duration-700 hover:scale-110"
                      />
                    </div>
                  </div>

                  {/* Enhanced Decorative Elements */}
                  <div className="absolute -top-4 -right-4 sm:-top-6 sm:-right-6 w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-[#E6F3F0] to-[#E6EFF6] animate-float-slow shadow-lg"></div>
                  <div
                    className="absolute -bottom-6 -left-6 sm:-bottom-8 sm:-left-8 w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-tl from-[#E6F3F0] to-[#E6EFF6] animate-float shadow-lg"
                    style={{ animationDelay: "2s" }}
                  ></div>
                </div>
              </div>
            </div>

            {/* Enhanced Founder Story */}
            <div className="space-y-8">
              <h3 className="font-heading text-3xl xl:text-4xl font-bold bg-gradient-to-r from-[#2C5364] to-[#203A43] bg-clip-text text-transparent">
                Neeru Gupta Mishra
              </h3>

              <div className="space-y-6 text-lg xl:text-xl leading-relaxed text-[#4A6670]/90">
                <p className="transition-all duration-300 hover:text-[#4A6670]">
                  Neeru Gupta Mishra received her teacher certification in
                  Satyananda Yoga Nidra® from Yoga Academy of North America,
                  which follows the Bihar School of Yoga tradition. She is also
                  certified as a Yoga teacher by Sri Sri School of Yoga and
                  Ministry of AYUSH, India and is registered as an E-RYT®200
                  with Yoga Alliance.
                </p>

                <p className="transition-all duration-300 hover:text-[#4A6670]">
                  After a demanding career in engineering and management, Neeru
                  turned to yoga in 2013 seeking alignment and balance. Inspired
                  by the impact of Hatha Yoga, she completed teacher training to
                  share its benefits with others. As her personal and teaching
                  practice evolved, she was drawn to Yoga Nidra for its calming
                  depth, and pursued teacher certification to guide students
                  through this restorative and liberating practice.
                </p>

                <p className="transition-all duration-300 hover:text-[#4A6670]">
                  Her passion grew into founding Cittasya®, providing sessions
                  to help people from all walks of life to slow down, feel safe,
                  and rest deeply. When not teaching, Neeru continues to study
                  Vedanta, Vedic chanting, Sanskrit, and Ayurveda to complement
                  her teaching style and to deepen the company's offerings.
                </p>
              </div>
            </div>
          </div>

          {/* Enhanced Certifications Section */}
          {/* <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h4 className="font-heading text-2xl md:text-3xl font-bold bg-gradient-to-r from-[#2C5364] to-[#203A43] bg-clip-text text-transparent mb-4">
                Certifications & Ongoing Studies
              </h4>
              <div className="w-24 h-1 bg-gradient-to-r from-[#89B8C2] via-[#7AA6B6] to-[#89B8C2] rounded-full mx-auto"></div>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                {
                  title: "Satyananda Yoga Nidra®",
                  org: "Yoga Academy of North America",
                  gradient: "from-blue-50 to-white",
                },
                {
                  title: "Hatha Yoga Certification",
                  org: "Sri Sri School of Yoga/ Ministry of AYUSH",
                  gradient: "from-green-50 to-white",
                },
                {
                  title: "E-RYT®200",
                  org: "Yoga Alliance Registered",
                  gradient: "from-orange-50 to-white",
                },
                {
                  title: "Vedanta & Vedic Chanting",
                  org: "Philosophy and Sacred sound",
                  gradient: "from-blue-50 to-green-50",
                },
                {
                  title: "Samskritam",
                  org: "Language of Scriptures",
                  gradient: "from-green-50 to-white",
                },
                {
                  title: "Ayurvedic Wellness",
                  org: "Holistic Healing Science",
                  gradient: "from-orange-50 to-white",
                },
              ].map((cert, index) => (
                <div
                  key={index}
                  className={`bg-gradient-to-br ${cert.gradient} p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 group`}
                >
                  <div className="flex items-start space-x-4">
                    <div className="w-2 h-2 rounded-full bg-gradient-to-r from-[#89B8C2] to-[#7AA6B6] mt-2 group-hover:scale-150 transition-transform duration-300"></div>
                    <div>
                      <h5 className="font-semibold text-lg text-[#2C5364] mb-2 group-hover:translate-x-1 transition-transform duration-300">
                        {cert.title}
                      </h5>
                      <p className="text-[#4A6670]/80 text-sm group-hover:translate-x-1 transition-transform duration-300">
                        {cert.org}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default FounderStory;
